module.exports = __webpack_public_path__ + "static/media/shareLink.68a3d04e.svg";